// IconWrapper.tsx
import React from 'react';
import type { IconType } from 'react-icons';

interface IconWrapperProps {
  icon: IconType;
  className?: string;
  size?: string | number;
}

export const IconWrapper: React.FC<IconWrapperProps> = ({ icon: Icon, className, size }) => {
  const element = Icon({ className, size });

  // Vérification explicite pour assurer que l'élément n'est pas undefined
  return <>{element ?? null}</>;
};